module.exports = __webpack_public_path__ + "img/mediterraneo-cs.7529c125.png";